import React from 'react';
import { Check, Clock, AlertCircle, Circle, ChevronDown } from 'lucide-react';
import { PROFILE_TABS, primaryOf } from './model';

const TONE_ICON = { done: Check, wait: Clock, hot: AlertCircle, idle: Circle };
const TONE_WORD = { done: 'Completed', wait: 'Outstanding', hot: 'Needs attention', idle: 'Not started' };

// Completed / outstanding / attention at a glance for each client workstream.
export const StatusStrip = ({ streams, onGo }) => (
  <div className="cpx-status" data-testid="obd-status-strip">
    {streams.map((s) => { const Icon = TONE_ICON[s.tone]; return (
      <button type="button" key={s.key} className={`cpx-st t-${s.tone}`} onClick={() => onGo(s.tab)} data-testid={`obd-status-${s.key}`} data-tone={s.tone}>
        <span className="cpx-st-ic"><Icon size={15} strokeWidth={2.6} /></span>
        <span className="cpx-st-body"><span className="cpx-st-l">{s.label}<em>{TONE_WORD[s.tone]}</em></span><b>{s.value}</b><small>{s.sub}</small></span>
      </button>
    ); })}
  </div>
);

// Sticky action bar: the everyday actions, one click away.
export const ActionBar = ({ actions, primary, more }) => (
  <div className="cpx-bar" data-testid="obd-action-bar">
    <div className="cpx-bar-scroll" data-testid="obd-header-actions">
      {actions.filter(Boolean).map(({ key, label, Icon, onClick, testId, badge }) => (
        <button type="button" key={key} className="cpx-act" onClick={onClick} data-testid={testId} title={label} aria-label={label}><Icon size={14} /><span className="cpx-act-t">{label}</span>{badge ? <span className="cpx-badge">{badge}</span> : null}</button>
      ))}
      {more}
    </div>
    <div className="cpx-bar-primary">{primary}</div>
  </div>
);

// Primary tabs + sub-section pills.
export const ProfileTabs = ({ tab, setTab, counts, dots }) => {
  const cur = primaryOf(tab);
  return (
    <div className="cpx-tabs-wrap">
      <nav className="cpx-tabs" role="tablist" data-testid="obd-tabs">
        {PROFILE_TABS.map((t) => { const n = t.subs.reduce((s, k) => s + (counts[k] || 0), 0); const on = t.key === cur.key; return (
          <button type="button" role="tab" aria-selected={on} key={t.key} className={on ? 'on' : ''} onClick={() => setTab(t.subs[0])} data-testid={`obd-ptab-${t.key}`}>
            {dots[t.key] && <span className={`cpx-dot t-${dots[t.key]}`} />}{t.label}{n ? <span className="cpx-n">{n}</span> : null}
          </button>
        ); })}
      </nav>
      {cur.subs.length > 1 && (
        <div className="cpx-subs" role="tablist" data-testid="obd-subtabs">
          {cur.subs.map((s) => <button type="button" role="tab" aria-selected={tab === s} key={s} className={tab === s ? 'on' : ''} onClick={() => setTab(s)} data-testid={`obd-tab-${s.toLowerCase().replace(' ', '-')}`}>{s}{counts[s] ? <span className="cpx-n">{counts[s]}</span> : null}</button>)}
        </div>
      )}
    </div>
  );
};

// Collapsible section used for secondary Overview detail.
export const Fold = ({ title, sub, children, open = false, testId }) => (
  <details className="cpx-fold" open={open} data-testid={testId}>
    <summary><span><b>{title}</b>{sub && <small>{sub}</small>}</span><ChevronDown size={16} className="chev" /></summary>
    <div className="cpx-fold-body">{children}</div>
  </details>
);
